import React, { Suspense, useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { getConfig } from "@/get-config";
import router from "@/routes";
import { store } from "@/store";
import { LoadScript } from "@react-google-maps/api";
import "./index.css";
const Modal = React.lazy(() => import("@/common/modal/modal"));
const CookiesBanner = React.lazy(() => import("./features/CookiesBanner"));

import { LanguageProvider, useLanguage } from "./hook/useLanguage";
import LoaderIconAnimated from "@/assets/svg/home/LoaderIconAnimated";

const theme = {
  token: {
    colorPrimary: "#7B9E7E",
    algorithm: true
  },
  components: {
    Input: {
      colorPrimary: "#7B9E7E",
      algorithm: true // Enable algorithm
    },
    Button: {
      // Customize the primary button's color
      colorPrimary: "#7B9E7E"
      // Border radius for buttons
    }
  }
};

// -----------------------------------------------
// CONFIG
// -----------------------------------------------
const { googleClientID, googleMap } = getConfig();

const AppContent = () => {
  const { direction, antdLocale } = useLanguage();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleLoad = () => {
      setLoading(false);
    };
    window.addEventListener("load", handleLoad);

    // Cleanup
    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, []);

  if (typeof global === "undefined") {
    window.global = window;
  }

  return (
    <ConfigProvider theme={theme} direction={direction} locale={antdLocale}>
      <GoogleOAuthProvider clientId={googleClientID}>
        {/* Show loading overlay until FCP */}
        <Provider store={store}>
          {loading ? (
            <div className="loading-overlay">
              <LoaderIconAnimated />
            </div>
          ) : null}
          <LoadScript
            googleMapsApiKey={googleMap}
            libraries={["places"]}
            language="en"
            loadingElement={
              <div className="loading-overlay">
                {/* <Spin size="large" /> */}
                <LoaderIconAnimated />
              </div>
            }>
            <RouterProvider
              future={{ v7_startTransition: true }}
              router={router}
            />
          </LoadScript>
          <Suspense fallback={null}>
            <Modal />
            <CookiesBanner />
          </Suspense>
        </Provider>
      </GoogleOAuthProvider>
    </ConfigProvider>
  );
};

const App = () => (
  <LanguageProvider>
    <AppContent />
  </LanguageProvider>
);

export default App;
